import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  isLoading: false,
  openModalUserOrderDetail: false,
};

const slice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // OPEN MODAL

    onOpenModalUserOrderdetailPopup(state) {
      state.openModalUserOrderDetail = true;
    },

    // CLOSE MODAL

    onCloseModalForUserOrderDetail(state) {
      state.openModalUserOrderDetail = false;
    },

    onCloseModal(state) {
      state.openModalUserOrderDetail = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onCloseModal, onOpenModalUserOrderdetailPopup,  onCloseModalForUserOrderDetail } = slice.actions;
